import { createContext } from 'react';
import { StickyElement } from '../types/sticky-element.type';

export type StickyContextType = {
    elements: StickyElement[];
    addElement: (element: StickyElement) => number;
    updateElement: (order: number, height: number, offsetTop: number) => number;
    removeElement: (order: number) => void;
    scrollToView: (
        dialog: HTMLElement | null | undefined,
        element: StickyElement,
    ) => void;
};
export const StickyContext = createContext<StickyContextType>({
    elements: [],
    addElement: (): number => {
        return 0;
    },
    updateElement: (): number => {
        return 0;
    },
    removeElement: () => {},
    scrollToView: () => {},
});
